import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .action {
      position: relative;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         margin-top: 3px;
         .line {
            margin-bottom: 0;
            &::after { display: none; }
         }
      }
      .withBorder {
         &.download {
            margin-left: 7.5px;
         }
         &.delete {
            margin-left: 7.5px;
            border-color: #E02424;
            color: #E02424;

            &:hover {
               background-color: #E02424;
               color: #fff;
               box-shadow: 0 0 5px #E02424;
            }
            &:disabled:hover {
               background-color: transparent;
               color: #E02424;
               border-color: #E02424;
               box-shadow: 0 0 0;
            } 
         }
      }
   } 
   .textInput {
      margin-top: 10px;
      h4 {
         width: 105px;
      }
   }
   .select {
      h4 { width: 85px; }
      &:not(:first-of-type) {
         margin-top: 10px;
      }
   }
   .dateInput {
      margin-top: 10px;
      h4, input {
         font-size: 15px;
      }
      h4 {
         margin-right: 20px;
      }
   }
   p {
      width: 340px !important;
   }
   .filesEdit {
      top: 0 !important;
      right: calc(100% + 22px) !important;
      width: 250px !important;
      height: auto !important;
      max-height: 200px;

      .checkbox {
         height: auto !important;
         max-height: 186px;

         > div label {
            width: calc(240px - 17px - 10px - 15px) !important;
         }
      }
   }
`;